var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "820.444px",
    height: "595.281px",
    viewBox: "21.445 0 820.444 595.281",
    enableBackground: "new 21.445 0 820.444 595.281",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ecoe_Icons-29",
    transform: "translate(-8.279 -9.64)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_324",
    opacity: 0.5,
    fill: "#EAF9FA",
    cx: 275.294,
    cy: 250.313,
    rx: 240.032,
    ry: 240.032
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3320",
    x: 632.675,
    y: 262.047,
    fill: "#0A2240",
    width: 94.946,
    height: 36.272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3321",
    x: 632.675,
    y: 356.993,
    fill: "#0A2240",
    width: 94.946,
    height: 36.272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3322",
    x: 632.675,
    y: 463.675,
    fill: "#0A2240",
    width: 94.946,
    height: 36.271
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3323",
    x: 420.38,
    y: 175.636,
    fill: "#0A2240",
    width: 94.946,
    height: 36.271
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3324",
    x: 420.38,
    y: 271.649,
    fill: "#0A2240",
    width: 94.946,
    height: 36.271
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3325",
    x: 420.38,
    y: 378.33,
    fill: "#0A2240",
    width: 94.946,
    height: 36.271
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3271",
    fill: "#0A2240",
    d: "M795.897,569.289V140.431H603.871V10.28H288.096v557.941h-58.675v36.272h619.816v-36.272 h-53.34V569.289z M498.257,492.479v76.811H392.643v-76.811H498.257z M355.305,456.207v113.082h-30.938V47.618h242.166v521.671 h-32.005V456.207H355.305z M757.492,177.77v391.52H602.805V176.702L757.492,177.77z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.8690b832d8f10ff8863dc75334da38e8.svg";
export { ForwardRef as ReactComponent };